import { styled } from 'styled-components';

export const StyledDatesTitle = styled.div`
  font-size: 24px;
  text-align: center;
  font-weight: 900;
  margin-bottom: 30px;
`;
